import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

type HeadFilterSelectFieldProps = {
  filterValue: string;
  setFilterValue: (value: string) => void;
  options: { value: string; label: string }[];
  selectedColumn: { label?: string } | null;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function HeadFilterSelectField({
  filterValue,
  setFilterValue,
  options,
  selectedColumn,
  t,
}: HeadFilterSelectFieldProps) {
  return (
    <TextField
      select
      fullWidth
      size="small"
      label={`${t('SELECT')} ${selectedColumn?.label}`}
      value={filterValue}
      onChange={(e) => setFilterValue(e.target.value)}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
